import * as React from "react";
import { Modal, ModalBody } from 'reactstrap';

class CriticalUpdateModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { modalVisible: true };
        this.modal = React.createRef();
        this.tick = this.tick.bind(this);
        this.countDown = props.counterValue * 60 * 1000;
    }

    componentDidMount() {       
        if(window)
            this.timerId = window.setInterval(this.tick, 1000);
    }
    
    componentWillUnmount() {
        this.clearInterval();
    }

    closeModal() {
        this.setState({ modalVisible: false });
    }

    tick() {
        this.countDown -= 1000;
        const min = Math.floor(this.countDown / (60 * 1000));
        const sec = Math.floor((this.countDown - (min * 60 * 1000)) / 1000);
        if (this.countDown <= 0) {
            this.clearInterval();
            this.refreshApp();
        } else {
            const timer = this.modal.current.querySelector(".timer");
            if (timer)
                timer.innerHTML = (min < 10 ? "0" + min : min ) + " : " + (sec < 10 ? "0" + sec : sec);
        }
    }

    clearInterval() {
        if (this.timerId) {
            if (window) {
                window.clearInterval(this.timerId);
            }
            this.timerId = null;
        }
    }   

    refreshApp() {
        if (window) {
            window.location.reload(true);
            this.closeModal();
        }
    }

    render() {
        const { message, counterValue } = this.props;        
        const { modalVisible } = this.state;
        return (
            <div>
                <Modal className="refresh-modal" isOpen={modalVisible} centered>
                    <ModalBody>
                        <div className="row">
                            <div className="col-12">
                                <p>{message ? message : 'Your session will be refreshed for an update in'}</p>
                                <div className="timer-container" ref={this.modal}>
                                        <div className="timer">{counterValue} : 00</div>
                                        <div><span>MIN</span><span>SEC</span></div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card-separator card-align" />
                                    </div>
                                </div>
                                <div className="row refresh-link-container">
                                    <div className="col-12 link-center" onClick={() => this.refreshApp()}> REFRESH NOW </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}


export default CriticalUpdateModal;